export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-price-tag-3-line',
      title: 'Prezzi Competitivi',
      description:
        'Offriamo i migliori prezzi all\'ingrosso del mercato grazie ai nostri rapporti diretti con i produttori e distributori autorizzati',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garanzia Ufficiale',
      description:
        'Tutti i prodotti sono coperti da garanzia ufficiale del produttore con assistenza post-vendita dedicata',
    },
    {
      icon: 'ri-stock-line',
      title: 'Ampia Disponibilità',
      description:
        'Magazzino sempre rifornito con oltre 5000 prodotti disponibili per consegne immediate',
    },
    {
      icon: 'ri-team-line',
      title: 'Consulenza Professionale',
      description:
        'Team di esperti a tua disposizione per consigli tecnici e supporto nella scelta dei prodotti',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Resi Facili',
      description:
        'Politica di reso semplice e trasparente per garantire la massima soddisfazione del cliente',
    },
    {
      icon: 'ri-secure-payment-line',
      title: 'Pagamenti Sicuri',
      description:
        'Diverse modalità di pagamento sicure e flessibili per facilitare le tue transazioni',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-gray-900 mb-6 leading-tight">
            Perché Scegliere
            <span className="block text-orange-500">Word Art S.r.l.s</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            La nostra esperienza e professionalità al servizio del tuo business
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 hover:bg-orange-50 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-2xl mb-6 group-hover:scale-110 transition-transform shadow-lg">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
